import React from 'react'

import { FormGroup, HolderTitle } from '../'
import { FormValues } from 'donate/types'
import { StarredField } from 'shared'
import { connect } from 'formik'

export const CompanyFields = connect<{}, FormValues>(({ formik }) => {
  if (!formik.values._company_donation) return null

  return (
    <>
      <div className="donations-form-holder-label">
        <HolderTitle />
      </div>
      <StarredField name="company_name" placeholder={i18n.t('donate.attributes.company_name')} component={FormGroup} />
    </>
  )
})
